const MoinAhmedMalik = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:flex md:grid md:justify-center lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] font-bold">
              Moin Ahmed Malik
            </h1>
            <p>CEO TCS Logistics Private Limited</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/moin-ahmed-malik.jpg"
              alt=""
              className="xl:h-[26rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">
              Moin Ahmed Malik
            </h1>
            <p>CEO TCS Logistics Private Limited</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          As a seasoned professional with more than 35 years of experience,
          before joining TCS, Moin Ahmed Malik was working as the CEO of Agility
          Logistics Private Limited. At TCS, he is personally overseeing the
          modernisation and transformation of warehousing, distribution, and TIR
          initiatives (Transports Internationaux Routiers).
        </p>
        <p>
          Moin stepped in the courier and logistics industry by joining TCS in
          1984. By 1997 he had risen to the highest management levels, when he
          decided to move to Xpress Pak Logistics & Geo-logistics which later
          merged and operated globally as the Agility Logistics. His expertise
          include establishing and expanding the logistics and transportation
          network in Pakistan and across the borders, while ensuring high
          quality services to the customers.
        </p>
        <p>
          Having expertise in all areas, including courier, freight forwarding,
          3PL and distribution, and being an active member of ACAAP, PIFFA and
          the Founder Chairman of FOAP (Fleet Operators Association of
          Pakistan), he enjoys a unique privilege of resolving complex
          logistics-related issues which require extensive connections with
          international bodies and government personnels.
        </p>
        <p>
          Moin Malik’s curriculum vitae includes a Masters degree in Business
          Administration with major in Marketing and various professional
          programmes’ certifications. He is a family man who likes most the time
          spent with his family. He also plays golf, tennis, and enjoys reading.
        </p>
        {/* <p>
          Moin expertise includes establishing the logistics and transportation network in Pakistan 
          and across border and ensuring high quality services to the customers. He has experience in 
          all areas like Courier, Freight Forwarding, 3PL Logistics and Distribution Services. Being 
          an active member of ACAAP, PIFFA and Founder Chairman of FOAP (Fleet Operators Association of Pakistan), 
          he has been networking with International Bodies and Government Ministries to resolve issues related to 
          the Logistics Industry. 
          </p>
          <p>
            He holds a degree of Masters in Business Administration (Marketing) and numerous professional education 
            courses to his credit.
          </p>
          <p>
            Moin is a family man, who enjoys spending time with his family, playing golf, tennis and reading.
          </p> */}
      </div>
    </div>
  );
};

export default MoinAhmedMalik;
